"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dentalClinicApi = require("@/api/dentalClinicApi");
var _logistics = require("@/api/logistics");
var _uploadPicture = _interopRequireDefault(require("@/components/uploadPicture"));
var _productBinding = _interopRequireDefault(require("./productBinding"));
var _dentalProductApi = require("@/api/dentalProductApi");
var _systemSetting = require("@/api/systemSetting");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ClinicList',
  components: {
    uploadPicture: _uploadPicture.default,
    ProductBinding: _productBinding.default
  },
  data: function data() {
    return {
      // 分销授权相关
      distributionDialogVisible: false,
      distributionList: [{
        id: 1,
        name: '华东云端-平台自营小程序'
      }, {
        id: 2,
        name: '福彩途家-庐芹'
      }],
      selectedDistributions: [],
      currentClinic: null,
      distributionSubmitting: false,
      // 遮罩层
      loading: false,
      // 详情加载状态
      detailLoading: false,
      // 总条数
      total: 0,
      // 区域选项
      regionOptions: [],
      // 表单和详情页使用的区域选项
      formRegionOptions: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        keyword: '',
        regionIds: [],
        region: '',
        status: '-1'
      },
      // 表格数据
      tableData: [],
      // 对话框标题
      dialogTitle: '',
      // 对话框可见性
      dialogVisible: false,
      // 详情对话框可见性
      detailDialogVisible: false,
      // 表单数据
      form: {
        id: null,
        name: '',
        subTitle: '',
        contactPerson: '',
        contactPhone: '',
        address: '',
        longitude: '',
        latitude: '',
        regionIds: [],
        provinceId: '',
        cityId: '',
        districtId: '',
        region: '',
        appointmentStartTime: '',
        appointmentEndTime: '',
        status: 1,
        logo: '',
        mainImage: '',
        detailImage: '',
        tags: '',
        introduction: ''
      },
      // 详情数据
      detail: {
        id: null,
        name: '',
        subTitle: '',
        contactPerson: '',
        contactPhone: '',
        address: '',
        longitude: '',
        latitude: '',
        region: '',
        appointmentStartTime: '',
        appointmentEndTime: '',
        status: 1,
        logo: '',
        mainImage: '',
        detailImage: '',
        tags: '',
        introduction: ''
      },
      // 表单验证规则
      rules: {
        name: [{
          required: true,
          message: '请输入诊所名称',
          trigger: 'blur'
        }, {
          min: 2,
          max: 100,
          message: '长度在 2 到 100 个字符',
          trigger: 'blur'
        }],
        contactPerson: [{
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        }, {
          min: 2,
          max: 20,
          message: '长度在 2 到 20 个字符',
          trigger: 'blur'
        }],
        contactPhone: [{
          required: true,
          message: '请输入联系人电话号码',
          trigger: 'blur'
        }, {
          pattern: /^(1[3-9]\d{9}|0\d{2,3}-?\d{7,8})$/,
          message: '请输入正确的电话号码格式(手机11位数字或座机区号-电话号码)',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入地址',
          trigger: 'blur'
        }, {
          min: 5,
          max: 200,
          message: '地址长度在5-200个字符之间',
          trigger: 'blur'
        }],
        longitude: [{
          required: true,
          message: '请输入经度',
          trigger: 'blur'
        }, {
          pattern: /^-?((0|1?[0-7]?[0-9]?)(\.[0-9]*)?|180(\.0*)?)$/,
          message: '请输入正确的经度格式(-180~180)',
          trigger: 'blur'
        }],
        latitude: [{
          required: true,
          message: '请输入纬度',
          trigger: 'blur'
        }, {
          pattern: /^-?((0|[1-8]?[0-9]?)(\.[0-9]*)?|90(\.0*)?)$/,
          message: '请输入正确的纬度格式(-90~90)',
          trigger: 'blur'
        }],
        regionIds: [{
          required: true,
          message: '请选择所属地区',
          trigger: 'change'
        }],
        appointmentStartTime: [{
          message: '请选择预约开始时间',
          trigger: 'change'
        }],
        appointmentEndTime: [{
          message: '请选择预约结束时间',
          trigger: 'change'
        }],
        introduction: [{
          max: 500,
          message: '简介最多500个字符',
          trigger: 'blur'
        }],
        mainImage: [{
          required: true,
          message: '请上传至少一张诊所主图',
          trigger: 'change'
        }]
      },
      // 图片列表
      mainImageList: [],
      detailImageList: [],
      // 标签输入
      showTagInput: false,
      newTag: '',
      tagsList: [],
      currentUploadType: 'main',
      // 新增 currentUploadType 属性
      dragging: null,
      // 图片预览
      previewVisible: false,
      previewImageUrl: '',
      // 商品绑定相关
      bindingDialogVisible: false,
      currentClinicId: null,
      currentClinicName: '',
      productsLoading: false,
      clinicProducts: [],
      productsQuery: {
        page: 1,
        limit: 10
      },
      productsTotal: 0,
      productDetailDialogVisible: false,
      currentProductDetail: {},
      // logo上传相关
      logoImageUrl: ''
    };
  },
  computed: {
    // 详情页面的标签数组
    detailTagsList: function detailTagsList() {
      if (!this.detail.tags) return [];
      if (Array.isArray(this.detail.tags)) return this.detail.tags;
      return typeof this.detail.tags === 'string' ? this.detail.tags.split(',') : [];
    },
    // 详情页面的图片数组
    detailImageArray: function detailImageArray() {
      // 如果有 detailImages 数组属性，优先使用
      if (this.detail.detailImages && Array.isArray(this.detail.detailImages)) {
        return this.detail.detailImages;
      }
      // 如果有 detailImage 字符串属性，转换为数组
      if (this.detail.detailImage) {
        return typeof this.detail.detailImage === 'string' ? this.detail.detailImage.split(',').filter(function (url) {
          return url.trim() !== '';
        }) : [];
      }
      return [];
    },
    // 详情页面的主图数组
    mainImageArray: function mainImageArray() {
      // 如果有 mainImages 数组属性，优先使用
      if (this.detail.mainImages && Array.isArray(this.detail.mainImages)) {
        return this.detail.mainImages;
      }
      // 如果有 mainImage 字符串属性，转换为数组
      if (this.detail.mainImage) {
        return typeof this.detail.mainImage === 'string' ? this.detail.mainImage.split(',').filter(function (url) {
          return url.trim() !== '';
        }) : [];
      }
      return [];
    }
  },
  watch: {},
  created: function created() {
    this.getRegionOptions();
    this.getList();
  },
  methods: {
    // 获取区域选项
    getRegionOptions: function getRegionOptions() {
      var _this = this;
      (0, _dentalClinicApi.getDentalCityList)().then(function (response) {
        _this.regionOptions = response || [];
        console.log('Region options loaded:', _this.regionOptions.length);
      }).catch(function (error) {
        _this.$message.error('获取地区数据失败: ' + (error && error.message ? error.message : '请重试'));
      });
    },
    // 处理区域选择变化
    handleRegionChange: function handleRegionChange(value) {
      console.log('Region change triggered with value:', value);

      // 清除之前的地区参数
      this.queryParams.region = '';
      if (value && value.length > 0) {
        // 使用 region 字段，但值是最后一级选择的值
        this.queryParams.region = value[value.length - 1];

        // 设置地区名称路径
        var _getRegionPath = function getRegionPath(options, ids) {
          var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          if (!options || !ids || ids.length === 0) return path;
          var currentId = ids[0];
          var currentOption = options.find(function (opt) {
            return opt.key === currentId;
          });
          if (currentOption) {
            path.push(currentOption.value);
            if (ids.length > 1 && currentOption.children) {
              return _getRegionPath(currentOption.children, ids.slice(1), path);
            }
          }
          return path;
        };
        var regionPath = _getRegionPath(this.regionOptions, value);
        if (regionPath.length > 0) {
          this.queryParams.regionName = regionPath.join('/');
        }
      }
      console.log('Updated queryParams:', {
        region: this.queryParams.region
      });
    },
    // 获取列表数据
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      var params = {
        page: this.queryParams.pageNum,
        limit: this.queryParams.pageSize,
        keyword: this.queryParams.keyword || undefined,
        region: this.queryParams.region || undefined,
        status: this.queryParams.status !== '-1' ? this.queryParams.status : undefined
      };
      console.log('API call params:', params);
      (0, _dentalClinicApi.getClinicList)(params).then(function (response) {
        if (response) {
          _this2.tableData = response.list || [];

          // 确保每条记录都有regionName
          _this2.tableData.forEach(function (item) {
            if (!item.regionName && item.region) {
              // 如果没有regionName但有region，尝试使用region作为显示值
              item.regionName = item.region;
            }
          });
          _this2.total = response.total || 0;
        } else {
          _this2.tableData = [];
          _this2.total = 0;
          _this2.$message.error('获取数据失败');
        }
        _this2.loading = false;
      }).catch(function (error) {
        _this2.tableData = [];
        _this2.total = 0;
        _this2.$message.error('获取数据失败: ' + (error.message || error));
        _this2.loading = false;
      });
    },
    // 查询按钮
    handleQuery: function handleQuery() {
      this.queryParams.pageNum = 1;
      console.log('Querying with params:', this.queryParams);
      this.getList();
    },
    // 重置按钮
    resetQuery: function resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        keyword: '',
        regionIds: [],
        region: '',
        status: '-1'
      };
      this.getList();
    },
    // 新增按钮
    handleAdd: function handleAdd() {
      var _this3 = this;
      this.dialogTitle = '新增诊所';
      this.resetForm();
      // 确保新增页面加载地区数据
      this.loadFormRegionOptions().then(function () {
        _this3.dialogVisible = true;
      });
    },
    // 加载表单使用的地区选项
    loadFormRegionOptions: function () {
      var _loadFormRegionOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(!this.formRegionOptions || this.formRegionOptions.length === 0)) {
                _context.n = 4;
                break;
              }
              _context.p = 1;
              _context.n = 2;
              return (0, _logistics.treeLevel3)();
            case 2:
              response = _context.v;
              this.formRegionOptions = response || [];
              console.log('Form region options loaded:', this.formRegionOptions.length);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error('获取地区数据失败，请重试');
            case 4:
              return _context.a(2, Promise.resolve());
          }
        }, _callee, this, [[1, 3]]);
      }));
      function loadFormRegionOptions() {
        return _loadFormRegionOptions.apply(this, arguments);
      }
      return loadFormRegionOptions;
    }(),
    // 查看按钮
    handleDetail: function handleDetail(row) {
      var _this4 = this;
      // 先重置详情数据，避免显示上次的数据
      this.resetDetailData();
      // 再打开对话框，等加载完数据再显示
      this.detailDialogVisible = true;
      // 延迟一下再加载数据，确保对话框已经完全打开
      setTimeout(function () {
        _this4.getDetailData(row.id);
        // 加载诊所绑定的商品
        _this4.loadClinicProducts(row.id);
      }, 50);
    },
    // 重置详情数据
    resetDetailData: function resetDetailData() {
      this.detail = {
        id: null,
        name: '',
        subTitle: '',
        contactPerson: '',
        contactPhone: '',
        address: '',
        longitude: '',
        latitude: '',
        region: '',
        appointmentStartTime: '',
        appointmentEndTime: '',
        status: 1,
        logo: '',
        mainImage: '',
        detailImage: '',
        tags: '',
        introduction: ''
      };
      // 重置商品数据
      this.clinicProducts = [];
      this.productsTotal = 0;
      this.productsQuery = {
        page: 1,
        limit: 10
      };
    },
    // 加载诊所绑定的商品
    loadClinicProducts: function loadClinicProducts(clinicId) {
      var _this5 = this;
      if (!clinicId) return;
      this.productsLoading = true;
      var params = {
        page: this.productsQuery.page,
        limit: this.productsQuery.limit,
        keyword: this.productsQuery.keyword,
        status: this.productsQuery.status
      };
      (0, _dentalProductApi.getClinicProducts)(clinicId, params).then(function (res) {
        if (res && res.list) {
          _this5.clinicProducts = res.list;
          _this5.productsTotal = res.total || 0;

          // 确保图片和标签是数组格式
          _this5.clinicProducts.forEach(function (product) {
            if (typeof product.imageList === 'string') {
              product.imageList = product.imageList.split(',').filter(function (url) {
                return url && url.trim() !== '';
              });
            } else if (!Array.isArray(product.imageList)) {
              product.imageList = [];
            }
            if (typeof product.tagList === 'string') {
              product.tagList = product.tagList.split(',').filter(function (tag) {
                return tag && tag.trim() !== '';
              });
            } else if (!Array.isArray(product.tagList)) {
              product.tagList = [];
            }
          });
        } else {
          _this5.clinicProducts = [];
          _this5.productsTotal = 0;
        }
      }).catch(function (error) {
        console.error('获取诊所商品列表失败:', error);
        _this5.$message.error('获取诊所商品列表失败');
      }).finally(function () {
        _this5.productsLoading = false;
      });
    },
    // 编辑按钮
    handleEdit: function handleEdit(row) {
      var _this6 = this;
      this.resetForm(); // 先重置表单，确保没有遗留数据
      this.dialogTitle = '编辑诊所';

      // 先加载地区数据，再从API获取最新的诊所数据
      this.loadFormRegionOptions().then(function () {
        _this6.dialogVisible = true;

        // 显示加载中
        _this6.loading = true;

        // 通过API获取详细的诊所数据
        (0, _dentalClinicApi.getClinicInfo)(row.id).then(function (response) {
          if (!response) {
            _this6.$message.error('获取诊所详情失败');
            return;
          }
          console.log('获取到的诊所详情:', response);

          // 将API返回的数据赋值到表单
          _this6.form = {
            id: response.id,
            name: response.name || '',
            subTitle: response.subTitle || '',
            contactPerson: response.contactPerson || '',
            contactPhone: response.contactPhone || '',
            address: response.address || '',
            longitude: response.longitude || '',
            latitude: response.latitude || '',
            regionIds: [],
            provinceId: response.provinceId || '',
            cityId: response.cityId || '',
            districtId: response.districtId || '',
            region: response.region || '',
            appointmentStartTime: response.appointmentStartTime || '',
            appointmentEndTime: response.appointmentEndTime || '',
            status: typeof response.status === 'number' ? response.status : 1,
            logo: response.logo || '',
            mainImage: '',
            detailImage: '',
            tags: response.tags || '',
            introduction: response.introduction || ''
          };

          // 设置logo
          _this6.logoImageUrl = response.logo || '';

          // 处理标签，确保安全处理
          _this6.tagsList = response.tags && typeof response.tags === 'string' ? response.tags.split(',').filter(function (tag) {
            return tag && tag.trim() !== '';
          }) : Array.isArray(response.tags) ? response.tags : [];

          // 处理主图列表
          _this6.mainImageList = [];
          if (response.mainImages && Array.isArray(response.mainImages)) {
            _this6.mainImageList = response.mainImages.map(function (url, index) {
              return {
                name: "\u4E3B\u56FE".concat(index + 1),
                url: url,
                isLocal: false
              };
            });
            // 更新form中的mainImage字段
            _this6.form.mainImage = response.mainImages.join(',');
          } else if (response.mainImage && typeof response.mainImage === 'string') {
            var urls = response.mainImage.split(',').filter(function (url) {
              return url && url.trim() !== '';
            });
            _this6.mainImageList = urls.map(function (url, index) {
              return {
                name: "\u4E3B\u56FE".concat(index + 1),
                url: url,
                isLocal: false
              };
            });
            // 更新form中的mainImage字段
            _this6.form.mainImage = urls.join(',');
          }

          // 处理详情图列表
          _this6.detailImageList = [];
          if (response.detailImages && Array.isArray(response.detailImages)) {
            _this6.detailImageList = response.detailImages.map(function (url, index) {
              return {
                name: "\u8BE6\u60C5\u56FE".concat(index + 1),
                url: url,
                isLocal: false
              };
            });
            // 更新form中的detailImage字段
            _this6.form.detailImage = response.detailImages.join(',');
          } else if (response.detailImage && typeof response.detailImage === 'string') {
            var _urls = response.detailImage.split(',').filter(function (url) {
              return url && url.trim() !== '';
            });
            _this6.detailImageList = _urls.map(function (url, index) {
              return {
                name: "\u8BE6\u60C5\u56FE".concat(index + 1),
                url: url,
                isLocal: false
              };
            });
            // 更新form中的detailImage字段
            _this6.form.detailImage = _urls.join(',');
          }
          console.log('设置区域IDs:', response);

          // 处理地区回显 - 优先使用region字段来解析地区ID
          if (response.region && typeof response.region === 'string') {
            if (response.region.includes(',')) {
              // 如果region是以逗号分隔的ID字符串，直接解析
              var regionIds = response.region.split(',').map(function (id) {
                return parseInt(id, 10);
              }).filter(function (id) {
                return !isNaN(id);
              });
              console.log('从region解析的regionIds:', regionIds);
              if (regionIds.length > 0) {
                _this6.form.regionIds = regionIds;

                // 同时设置单独的ID字段，保持一致性
                _this6.form.provinceId = regionIds[0] || '';
                _this6.form.cityId = regionIds.length > 1 ? regionIds[1] : '';
                _this6.form.districtId = regionIds.length > 2 ? regionIds[2] : '';
              }
            }
            // 如果region是其他格式，尝试使用provinceId等字段
            else if (response.provinceId) {
              var _regionIds = [];
              _regionIds.push(response.provinceId);
              if (response.cityId) {
                _regionIds.push(response.cityId);
                if (response.districtId) {
                  _regionIds.push(response.districtId);
                }
              }
              console.log('从provinceId构建的regionIds:', _regionIds);
              _this6.form.regionIds = _regionIds;
            }
          }
          // 如果没有region字段，但有provinceId等字段
          else if (response.provinceId) {
            var _regionIds2 = [];
            _regionIds2.push(response.provinceId);
            if (response.cityId) {
              _regionIds2.push(response.cityId);
              if (response.districtId) {
                _regionIds2.push(response.districtId);
              }
            }
            console.log('从provinceId构建的regionIds:', _regionIds2);
            _this6.form.regionIds = _regionIds2;
          }
          console.log('设置后的表单数据:', JSON.stringify(_this6.form));
        }).catch(function (error) {
          console.error('获取诊所详情失败:', error);
          _this6.$message.error('获取诊所详情失败，请重试');
        }).finally(function () {
          _this6.loading = false;
        });
      });
    },
    // 从详情页编辑
    handleEditFromDetail: function handleEditFromDetail() {
      var _this7 = this;
      var detailId = this.detail.id;
      this.detailDialogVisible = false;
      this.dialogTitle = '编辑诊所';
      // 确保详情对话框关闭后再打开编辑对话框
      setTimeout(function () {
        // 先加载地区数据，再打开对话框
        _this7.loadFormRegionOptions().then(function () {
          _this7.dialogVisible = true;
          _this7.getFormData(detailId);
        });
      }, 100);
    },
    // 删除按钮
    handleDelete: function handleDelete(row) {
      var _this8 = this;
      this.$confirm('确认删除该诊所吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _dentalClinicApi.deleteClinic)(row.id).then(function (response) {
          if (response) {
            _this8.$message({
              type: 'success',
              message: '删除成功!'
            });
            _this8.getList();
          } else {
            _this8.$message.error(response.message || '删除失败');
          }
        }).catch(function (error) {
          _this8.$message.error('删除失败: ' + (error.message || error));
        });
      }).catch(function () {
        _this8.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 绑定商品
    handleBindProducts: function handleBindProducts(row) {
      console.log('Bind products clicked for clinic:', row);
      this.currentClinicId = row.id;
      this.currentClinicName = row.name;
      this.bindingDialogVisible = true;
    },
    // 分销授权
    handleDistribution: function handleDistribution(row) {
      console.log('分销授权 clicked for clinic:', row);
      this.currentClinic = row;
      this.distributionDialogVisible = true;
      this.loadDistributionList(row.id);
    },
    // 加载分销授权列表
    loadDistributionList: function loadDistributionList(clinicId) {
      var _this9 = this;
      // 获取分销商列表
      (0, _dentalClinicApi.getCompanyAppList)().then(function (response) {
        console.log('分销商列表:', response);
        if (response && Array.isArray(response)) {
          // 更新分销授权列表
          _this9.distributionList = response.map(function (item) {
            return {
              id: item.id,
              name: item.name || item.appName || "\u5E94\u7528".concat(item.id)
            };
          });

          // 获取当前诊所已有的授权
          (0, _dentalClinicApi.getClinicDistributionList)(clinicId).then(function (distributionResponse) {
            console.log('诊所已有授权:', distributionResponse);
            // 直接使用返回的数组，格式为 [35, 36, ...]
            if (distributionResponse && Array.isArray(distributionResponse)) {
              // 直接使用返回的ID数组
              _this9.selectedDistributions = distributionResponse.map(function (id) {
                return (
                  // 确保是数字类型
                  typeof id === 'string' ? parseInt(id, 10) : id
                );
              }).filter(function (id) {
                return id !== null && id !== undefined;
              }); // 过滤掉无效值
            } else if (_this9.currentClinic && _this9.currentClinic.distributorCustomerIds) {
              // 备选方案：从诊所对象获取授权信息
              if (Array.isArray(_this9.currentClinic.distributorCustomerIds)) {
                _this9.selectedDistributions = _this9.currentClinic.distributorCustomerIds;
              } else if (typeof _this9.currentClinic.distributorCustomerIds === 'string') {
                _this9.selectedDistributions = _this9.currentClinic.distributorCustomerIds.split(',').map(function (id) {
                  return parseInt(id, 10);
                });
              }
            } else {
              // 默认没有选中任何授权
              _this9.selectedDistributions = [];
            }
          }).catch(function (error) {
            console.error('获取诊所授权列表失败:', error);
            _this9.selectedDistributions = [];
          });
        }
      }).catch(function (error) {
        _this9.$message.error('获取分销商列表失败：' + (error.message || '未知错误'));
        // 使用测试数据作为备选
        _this9.distributionList = [{
          id: 1,
          name: '华东云端-平台自营小程序'
        }, {
          id: 2,
          name: '福彩途家-庐芹'
        }];
        _this9.selectedDistributions = [];
      });
    },
    // 关闭分销授权弹窗
    closeDistributionDialog: function closeDistributionDialog() {
      this.selectedDistributions = [];
      this.currentClinic = null;
    },
    // 提交分销授权
    submitDistribution: function submitDistribution() {
      var _this0 = this;
      if (!this.currentClinic || !this.currentClinic.id) {
        this.$message.error('未选择诊所');
        return;
      }
      this.distributionSubmitting = true;

      // 构建提交参数
      var params = {
        clinicId: this.currentClinic.id,
        distributorCustomerIds: this.selectedDistributions,
        remark: "" // 备注可以为空
      };

      // 调用API保存授权信息
      (0, _dentalClinicApi.submitClinicDistributionList)(params).then(function (response) {
        console.log('提交分销授权:', params);
        _this0.$message.success('分销授权设置成功');
        _this0.distributionDialogVisible = false;
        _this0.closeDistributionDialog();
      }).catch(function (error) {
        _this0.$message.error('分销授权设置失败：' + (error.message || '未知错误'));
      }).finally(function () {
        _this0.distributionSubmitting = false;
      });
    },
    // 商品绑定成功回调
    handleBindSuccess: function handleBindSuccess() {
      this.$message.success('商品绑定成功');
      this.getList();
    },
    // 获取表单数据
    getFormData: function getFormData(id) {
      var _this1 = this;
      // 加载数据
      var loadData = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var response, mainImages, detailImages, regionIdArray, regionNames, _findRegionId, regionIds, _t2;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                _context2.p = 0;
                _context2.n = 1;
                return (0, _dentalClinicApi.getClinicInfo)(id);
              case 1:
                response = _context2.v;
                if (response) {
                  _context2.n = 2;
                  break;
                }
                _this1.$message.error('获取详情失败');
                return _context2.a(2);
              case 2:
                _this1.form = _objectSpread({}, response);

                // 处理主图和详情图的显示 (支持数组和字符串格式)
                _this1.mainImageList = [];
                _this1.detailImageList = [];

                // 处理主图
                if (response.mainImages && Array.isArray(response.mainImages)) {
                  _this1.form.mainImage = response.mainImages.join(',');
                  _this1.mainImageList = response.mainImages.map(function (url, index) {
                    return {
                      name: "\u4E3B\u56FE".concat(index + 1),
                      url: url,
                      isLocal: false
                    };
                  });
                } else if (response.mainImage) {
                  mainImages = typeof response.mainImage === 'string' ? response.mainImage.split(',').filter(function (url) {
                    return url.trim() !== '';
                  }) : [];
                  _this1.form.mainImage = mainImages.join(',');
                  _this1.mainImageList = mainImages.map(function (url, index) {
                    return {
                      name: "\u4E3B\u56FE".concat(index + 1),
                      url: url,
                      isLocal: false
                    };
                  });
                }

                // 处理详情图
                if (response.detailImages && Array.isArray(response.detailImages)) {
                  _this1.form.detailImage = response.detailImages.join(',');
                  _this1.detailImageList = response.detailImages.map(function (url, index) {
                    return {
                      name: "\u8BE6\u60C5\u56FE".concat(index + 1),
                      url: url,
                      isLocal: false
                    };
                  });
                } else if (response.detailImage) {
                  detailImages = typeof response.detailImage === 'string' ? response.detailImage.split(',').filter(function (url) {
                    return url.trim() !== '';
                  }) : [];
                  _this1.form.detailImage = detailImages.join(',');
                  _this1.detailImageList = detailImages.map(function (url, index) {
                    return {
                      name: "\u8BE6\u60C5\u56FE".concat(index + 1),
                      url: url,
                      isLocal: false
                    };
                  });
                }

                // 处理标签
                if (Array.isArray(response.tags)) {
                  _this1.tagsList = _toConsumableArray(response.tags);
                } else if (typeof response.tags === 'string' && response.tags) {
                  _this1.tagsList = response.tags.split(',').filter(function (tag) {
                    return tag.trim() !== '';
                  });
                } else {
                  _this1.tagsList = [];
                }

                // 处理区域ID数据，用于级联选择器
                _this1.form.regionIds = [];

                // 如果后端返回的是以逗号分隔的地区ID字符串
                if (response.region && typeof response.region === 'string' && response.region.includes(',')) {
                  // 将逗号分隔的ID字符串转换为数组
                  regionIdArray = response.region.split(',').map(function (id) {
                    return parseInt(id, 10);
                  }).filter(function (id) {
                    return !isNaN(id);
                  });
                  if (regionIdArray.length > 0) {
                    _this1.form.regionIds = regionIdArray;
                    console.log('Parsed region IDs from comma-separated string:', regionIdArray);
                  }
                }
                // 优先使用 ID 来设置 regionIds（如果没有region字段或者region不是逗号分隔的ID）
                else if (response.provinceId) {
                  _this1.form.regionIds.push(response.provinceId);
                  if (response.cityId) {
                    _this1.form.regionIds.push(response.cityId);
                    if (response.districtId) {
                      _this1.form.regionIds.push(response.districtId);
                    }
                  }
                }
                // 如果没有 ID 但有 region 字符串（可能是地区名称路径），则根据 region 字符串查找对应的 ID
                else if (response.region && typeof response.region === 'string') {
                  regionNames = response.region.split('/'); // 递归查找地区 ID
                  _findRegionId = function findRegionId(options, name) {
                    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                    var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
                    if (!options || !options.length || !name || level >= regionNames.length) return path;
                    var region = options.find(function (item) {
                      return item.value === regionNames[level];
                    });
                    if (region) {
                      path.push(region.key);
                      if (level + 1 < regionNames.length && region.children && region.children.length) {
                        return _findRegionId(region.children, regionNames[level + 1], level + 1, path);
                      }
                    }
                    return path;
                  }; // 查找并设置 regionIds
                  if (regionNames.length > 0) {
                    regionIds = _findRegionId(_this1.formRegionOptions, regionNames[0]);
                    if (regionIds.length > 0) {
                      _this1.form.regionIds = regionIds;

                      // 同时设置个别的 ID 字段
                      _this1.form.provinceId = regionIds[0] || '';
                      _this1.form.cityId = regionIds.length > 1 ? regionIds[1] : '';
                      _this1.form.districtId = regionIds.length > 2 ? regionIds[2] : '';
                    }
                  }
                }
                console.log('Form loaded with regionIds:', _this1.form.regionIds);
                console.log('Form mainImage:', _this1.form.mainImage);
                console.log('Form detailImage:', _this1.form.detailImage);
                console.log('Tags:', _this1.tagsList);
                _context2.n = 4;
                break;
              case 3:
                _context2.p = 3;
                _t2 = _context2.v;
                _this1.$message.error('获取详情失败: ' + (_t2 && _t2.message ? _t2.message : '请重试'));
              case 4:
                return _context2.a(2);
            }
          }, _callee2, null, [[0, 3]]);
        }));
        return function loadData() {
          return _ref.apply(this, arguments);
        };
      }();

      // 执行加载
      loadData();
    },
    // 获取详情数据
    getDetailData: function getDetailData(id) {
      var _this10 = this;
      this.detailLoading = true;
      // 先确保区域选项已加载
      var loadRegionOptions = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
          var response, _t3;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                if (!(!_this10.formRegionOptions || _this10.formRegionOptions.length === 0)) {
                  _context3.n = 4;
                  break;
                }
                _context3.p = 1;
                _context3.n = 2;
                return (0, _logistics.treeLevel3)();
              case 2:
                response = _context3.v;
                _this10.formRegionOptions = response || [];
                _context3.n = 4;
                break;
              case 3:
                _context3.p = 3;
                _t3 = _context3.v;
                _this10.$message.error('获取地区数据失败，请重试');
              case 4:
                return _context3.a(2);
            }
          }, _callee3, null, [[1, 3]]);
        }));
        return function loadRegionOptions() {
          return _ref2.apply(this, arguments);
        };
      }();

      // 加载数据
      var loadData = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
          var response, regionIds, _findRegionPath, regionPath, _regionPath, findRegionName, provinceName, province, cityName, city, districtName, _t4;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                _context4.p = 0;
                _context4.n = 1;
                return loadRegionOptions();
              case 1:
                _context4.n = 2;
                return (0, _dentalClinicApi.getClinicInfo)(id);
              case 2:
                response = _context4.v;
                if (response) {
                  _context4.n = 3;
                  break;
                }
                _this10.$message.error('获取详情失败');
                return _context4.a(2);
              case 3:
                _this10.detail = response;

                // 确保主图和详情图字段一致，无论API返回的是什么格式
                if (response.mainImages && Array.isArray(response.mainImages)) {
                  _this10.detail.mainImage = response.mainImages.join(',');
                }
                if (response.detailImages && Array.isArray(response.detailImages)) {
                  _this10.detail.detailImage = response.detailImages.join(',');
                }

                // 处理区域ID数据，确保region值显示完整
                if (_this10.detail.region && typeof _this10.detail.region === 'string' && _this10.detail.region.includes(',')) {
                  // 如果region是逗号分隔的ID字符串，需要转换为地区名称路径
                  regionIds = _this10.detail.region.split(',').map(function (id) {
                    return parseInt(id, 10);
                  }).filter(function (id) {
                    return !isNaN(id);
                  });
                  if (regionIds.length > 0) {
                    // 递归查找地区名称
                    _findRegionPath = function findRegionPath(options, ids) {
                      var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                      if (!options || !options.length || !ids || ids.length === 0) return path;
                      var currentId = ids[0];
                      var currentOption = options.find(function (opt) {
                        return opt.id === currentId;
                      });
                      if (currentOption) {
                        path.push(currentOption.name);
                        if (ids.length > 1 && currentOption.child) {
                          return _findRegionPath(currentOption.child, ids.slice(1), path);
                        }
                      }
                      return path;
                    };
                    regionPath = _findRegionPath(_this10.formRegionOptions, regionIds);
                    if (regionPath.length > 0) {
                      _this10.detail.regionName = regionPath.join('/');
                      console.log('Converted region IDs to path:', regionPath);
                    }
                  }
                }
                // 如果region值为空但有区域ID，则动态构建一个region值
                else if (!_this10.detail.regionName && _this10.detail.provinceId) {
                  _regionPath = [];
                  findRegionName = function findRegionName(options, id) {
                    if (!options || !options.length) return null;
                    var region = options.find(function (item) {
                      return item.id === id;
                    });
                    return region ? region.name : null;
                  };
                  provinceName = findRegionName(_this10.formRegionOptions, _this10.detail.provinceId);
                  if (provinceName) {
                    _regionPath.push(provinceName);
                    if (_this10.detail.cityId) {
                      province = _this10.formRegionOptions.find(function (item) {
                        return item.id === _this10.detail.provinceId;
                      });
                      if (province && province.child) {
                        cityName = findRegionName(province.child, _this10.detail.cityId);
                        if (cityName) {
                          _regionPath.push(cityName);
                          if (_this10.detail.districtId && province.child) {
                            city = province.child.find(function (item) {
                              return item.id === _this10.detail.cityId;
                            });
                            if (city && city.child) {
                              districtName = findRegionName(city.child, _this10.detail.districtId);
                              if (districtName) {
                                _regionPath.push(districtName);
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  if (_regionPath.length > 0) {
                    _this10.detail.regionName = _regionPath.join('/');
                  }
                }
                _context4.n = 5;
                break;
              case 4:
                _context4.p = 4;
                _t4 = _context4.v;
                _this10.$message.error('获取详情失败: ' + (_t4.message || _t4));
              case 5:
                _context4.p = 5;
                _this10.detailLoading = false;
                return _context4.f(5);
              case 6:
                return _context4.a(2);
            }
          }, _callee4, null, [[0, 4, 5, 6]]);
        }));
        return function loadData() {
          return _ref3.apply(this, arguments);
        };
      }();

      // 执行加载
      loadData();
    },
    // 重置表单
    resetForm: function resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      this.form = {
        id: null,
        name: '',
        subTitle: '',
        contactPerson: '',
        contactPhone: '',
        address: '',
        longitude: '',
        latitude: '',
        regionIds: [],
        provinceId: '',
        cityId: '',
        districtId: '',
        region: '',
        appointmentStartTime: '',
        appointmentEndTime: '',
        status: 1,
        logo: '',
        mainImage: '',
        detailImage: '',
        tags: '',
        introduction: ''
      };
      this.logoImageUrl = '';
      this.tagsList = [];
      this.mainImageList = [];
      this.detailImageList = [];

      // 重置验证
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    // 处理标签关闭
    handleTagClose: function handleTagClose(tag) {
      this.tagsList = this.tagsList.filter(function (t) {
        return t !== tag;
      });
    },
    // 添加新标签
    handleAddTag: function handleAddTag() {
      if (this.newTag && this.tagsList.indexOf(this.newTag) === -1) {
        this.tagsList.push(this.newTag);
      }
      this.showTagInput = false;
      this.newTag = '';
    },
    // 处理每页显示数量变化
    handleSizeChange: function handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 处理页码变化
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    // 选择本地图片
    selectLocalImages: function selectLocalImages(type) {
      var maxCount = type === 'main' ? 5 : 10;
      var currentList = type === 'main' ? this.mainImageList : this.detailImageList;
      if (currentList.length >= maxCount) {
        this.$message.warning("\u6700\u591A\u53EA\u80FD\u4E0A\u4F20".concat(maxCount, "\u5F20").concat(type === 'main' ? '主图' : '详情图', "\uFF0C\u8BF7\u5148\u5220\u9664\u4E00\u4E9B\u56FE\u7247\u518D\u6DFB\u52A0\u3002"));
        return;
      }
      if (type === 'main') {
        this.$refs.mainImageInput.click();
      } else {
        this.$refs.detailImageInput.click();
      }
    },
    // 处理本地图片选择
    handleLocalImageSelected: function handleLocalImageSelected(type, event) {
      var _this11 = this;
      var files = event.target.files;
      if (!files || files.length === 0) return;
      var maxCount = type === 'main' ? 5 : 10;
      var currentList = type === 'main' ? this.mainImageList : this.detailImageList;
      var remainingSlots = maxCount - currentList.length;
      if (files.length > remainingSlots) {
        this.$message.warning("\u6700\u591A\u9009\u62E9".concat(maxCount, "\u5F20").concat(type === 'main' ? '主图' : '详情图', "\uFF01"));
      }

      // 处理每个选择的文件
      var processFiles = Array.from(files).slice(0, remainingSlots);
      processFiles.forEach(function (file) {
        // 验证文件类型
        if (!file.type.startsWith('image/')) {
          _this11.$message.error('请选择图片文件！');
          return;
        }

        // 创建FormData对象用于上传
        var formData = new FormData();
        formData.append('multipart', file);

        // 设置上传参数
        var params = {
          model: 'product',
          // 使用product模块
          pid: 1 // 使用商品图片分类ID
        };

        // 显示上传中的加载状态
        var loadingInstance = _this11.$loading({
          lock: true,
          text: '图片上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 调用公共图片上传API
        (0, _systemSetting.fileImageApi)(formData, params).then(function (response) {
          if (response) {
            // 上传成功，添加到图片列表
            if (type === 'main') {
              _this11.mainImageList.push({
                name: "\u4E3B\u56FE".concat(_this11.mainImageList.length + 1),
                url: response.url,
                isLocal: false
              });
              // 更新form中的mainImage字段，使用逗号分隔多个URL
              _this11.form.mainImage = _this11.mainImageList.map(function (item) {
                return item.url;
              }).join(',');
            } else {
              _this11.detailImageList.push({
                name: "\u8BE6\u60C5\u56FE".concat(_this11.detailImageList.length + 1),
                url: response.url,
                isLocal: false
              });
              // 更新form中的detailImage字段，使用逗号分隔多个URL
              _this11.form.detailImage = _this11.detailImageList.map(function (item) {
                return item.url;
              }).join(',');
            }
            _this11.$message.success('图片上传成功');
          } else {
            _this11.$message.error('图片上传失败: 服务器返回错误');
          }
        }).catch(function (error) {
          _this11.$message.error('图片上传失败: ' + (error.message || '未知错误'));
        }).finally(function () {
          loadingInstance.close();
        });
      });

      // 重置文件输入，允许重新选择相同的文件
      event.target.value = '';
    },
    // 移除图片
    handleRemoveImage: function handleRemoveImage(index, type) {
      if (type === 'main') {
        this.mainImageList.splice(index, 1);
        // 更新form中的mainImage字段，使用逗号分隔多个URL
        this.form.mainImage = this.mainImageList.length > 0 ? this.mainImageList.map(function (item) {
          return item.url;
        }).join(',') : '';
      } else {
        this.detailImageList.splice(index, 1);
        // 更新form中的detailImage字段，使用逗号分隔多个URL
        this.form.detailImage = this.detailImageList.length > 0 ? this.detailImageList.map(function (item) {
          return item.url;
        }).join(',') : '';
      }
    },
    // 预览图片
    previewImage: function previewImage(index, type) {
      var urls = [];
      if (type === 'main') {
        urls = this.mainImageList.map(function (img) {
          return img.url;
        });
      } else {
        urls = this.detailImageList.map(function (img) {
          return img.url;
        });
      }
      if (urls.length > 0) {
        // 首先尝试使用 Element UI 的 ImageViewer
        try {
          if (this.$ELEMENT && this.$ELEMENT.ImageViewer) {
            var ImageViewer = this.$ELEMENT.ImageViewer;
            var instance = new ImageViewer({
              urlList: urls,
              initialIndex: index
            });
            instance.show();
          } else {
            // 退回到内置预览模式
            this.previewImageUrl = urls[index];
            this.previewVisible = true;
          }
        } catch (e) {
          // 如果出错，使用内置预览
          console.error('Image preview error:', e);
          this.previewImageUrl = urls[index];
          this.previewVisible = true;
        }
      }
    },
    // 详情页预览图片
    previewDetailImage: function previewDetailImage(index, type) {
      var urls = [];
      if (type === 'main') {
        urls = this.mainImageArray;
      } else {
        urls = this.detailImageArray;
      }
      if (urls.length > 0) {
        // 使用内置预览模式，这样可以确保点击关闭功能正常工作
        this.previewImageUrl = urls[index];
        this.previewVisible = true;
      }
    },
    // 关闭预览
    closePreview: function closePreview() {
      this.previewVisible = false;
    },
    // 提交表单
    submitForm: function submitForm(formName) {
      var _this12 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          // 收集表单数据
          var formData = _objectSpread({}, _this12.form);

          // 处理标签
          formData.tags = _this12.tagsList.join(',');

          // 处理主图
          formData.mainImage = _this12.mainImageList && _this12.mainImageList.length > 0 ? _this12.mainImageList.map(function (item) {
            return item.url;
          }).join(',') : '';

          // 处理详情图
          formData.detailImage = _this12.detailImageList && _this12.detailImageList.length > 0 ? _this12.detailImageList.map(function (item) {
            return item.url;
          }).join(',') : '';

          // 处理区域
          if (formData.regionIds && formData.regionIds.length > 0) {
            formData.provinceId = formData.regionIds[0] || '';
            formData.cityId = formData.regionIds.length > 1 ? formData.regionIds[1] : '';
            formData.districtId = formData.regionIds.length > 2 ? formData.regionIds[2] : '';
            // 设置region字段为以逗号分隔的ID字符串，保持与后端格式一致
            formData.region = formData.regionIds.join(',');
          }
          console.log('提交的表单数据:', formData);
          _this12.loading = true;

          // 根据是新增还是编辑进行不同的API调用
          var apiPromise;
          if (formData.id) {
            // 编辑：使用正确的参数顺序调用updateClinic(id, data)
            apiPromise = (0, _dentalClinicApi.updateClinic)(formData.id, formData);
          } else {
            // 新增
            apiPromise = (0, _dentalClinicApi.saveClinic)(formData);
          }
          apiPromise.then(function (response) {
            // 检查实际返回结果，而不是简单地当作成功处理
            console.log('保存结果:', response);
            if (response && (response === true || response.code === 200 || response.data)) {
              _this12.$message.success(formData.id ? '诊所信息更新成功' : '诊所添加成功');
              _this12.dialogVisible = false;
              // 使用正确的方法名来刷新列表
              _this12.getList();
            } else {
              // 特定的错误处理
              var errorMessage = response && response.message ? response.message : formData.id ? '更新诊所失败' : '添加诊所失败';
              _this12.$message.error(errorMessage);
            }
          }).catch(function (error) {
            console.error(formData.id ? '更新诊所失败:' : '添加诊所失败:', error);
            _this12.$message.error(formData.id ? '更新诊所失败' : '添加诊所失败');
          }).finally(function () {
            _this12.loading = false;
          });
        } else {
          console.error('表单校验失败');
          return false;
        }
      });
    },
    // 处理商品操作成功
    handleProductsSuccess: function handleProductsSuccess() {
      // 重新加载商品列表
      if (this.detail.id) {
        this.loadClinicProducts(this.detail.id);
      }
      this.getList();
    },
    // 处理商品解绑
    handleUnbindProduct: function handleUnbindProduct(row) {
      var _this13 = this;
      this.$confirm("\u786E\u5B9A\u8981\u89E3\u9664\u5546\u54C1 \"".concat(row.productName, "\" \u4E0E\u8BCA\u6240\u7684\u7ED1\u5B9A\u5173\u7CFB\u5417?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = {
          clinicId: _this13.detail.id,
          productIds: [row.id]
        };
        (0, _dentalProductApi.unbindProductsFromClinic)(data).then(function () {
          _this13.$message.success('解除绑定成功');
          // 重新加载商品列表
          _this13.loadClinicProducts(_this13.detail.id);
        }).catch(function (error) {
          console.error('解除商品绑定失败:', error);
          _this13.$message.error('解除商品绑定失败');
        });
      }).catch(function () {});
    },
    // 处理商品查询
    handleProductsQuery: function handleProductsQuery() {
      if (this.detail.id) {
        this.loadClinicProducts(this.detail.id);
      }
    },
    // 处理商品分页大小变化
    handleProductsSizeChange: function handleProductsSizeChange(val) {
      this.productsQuery.limit = val;
      this.handleProductsQuery();
    },
    // 处理商品页码变化
    handleProductsCurrentChange: function handleProductsCurrentChange(val) {
      this.productsQuery.page = val;
      this.handleProductsQuery();
    },
    // 处理从详情页面绑定商品
    handleBindProductsFromDetail: function handleBindProductsFromDetail() {
      this.currentClinicId = this.detail.id;
      this.currentClinicName = this.detail.name;
      this.bindingDialogVisible = true;
    },
    // 处理查看商品详情
    handleViewProductDetail: function handleViewProductDetail(product) {
      // 创建一个临时的商品详情对象
      var productDetail = _objectSpread({}, product);
      if (typeof productDetail.imageList === 'string') {
        productDetail.imageList = productDetail.imageList.split(',').filter(function (url) {
          return url && url.trim() !== '';
        });
      } else if (!Array.isArray(productDetail.imageList)) {
        productDetail.imageList = [];
      }
      if (typeof productDetail.tagList === 'string') {
        productDetail.tagList = productDetail.tagList.split(',').filter(function (tag) {
          return tag && tag.trim() !== '';
        });
      } else if (!Array.isArray(productDetail.tagList)) {
        productDetail.tagList = [];
      }
      this.productDetailDialogVisible = true;
      this.currentProductDetail = productDetail;
    },
    // 搜索诊所
    remoteSearchClinic: function remoteSearchClinic(query) {
      var _this14 = this;
      if (query) {
        this.clinicLoading = true;
        (0, _dentalClinicApi.getDentalCityList)({
          keyword: query
        }).then(function (response) {
          // 适配后端返回的数据结构
          if (response) {
            _this14.clinicOptions = response;
          } else {
            _this14.clinicOptions = [];
          }
        }).catch(function (error) {
          console.error('搜索诊所失败:', error);
          _this14.clinicOptions = [];
        }).finally(function () {
          _this14.clinicLoading = false;
        });
      } else {
        this.clinicOptions = [];
      }
    },
    // 选择本地logo
    selectLocalLogo: function selectLocalLogo() {
      this.$refs.logoImageInput.click();
    },
    // 处理logo选择
    handleLogoSelected: function handleLogoSelected(event) {
      var _this15 = this;
      var files = event.target.files;
      if (!files || files.length === 0) return;
      var file = files[0];
      // 检查文件类型
      if (!file.type.includes('image/')) {
        this.$message.error('仅支持图片文件！');
        return;
      }

      // 上传图片
      var formData = new FormData();
      formData.append('multipart', file); // 修改为multipart与主图/详情图保持一致

      // 设置上传参数
      var params = {
        model: 'dental',
        // 使用dental模块
        pid: 1 // 使用诊所图片分类ID
      };

      // 显示上传中的加载状态
      var loadingInstance = this.$loading({
        lock: true,
        text: 'Logo上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 调用公共图片上传API并传递params参数
      (0, _systemSetting.fileImageApi)(formData, params).then(function (response) {
        if (response && response.url) {
          // 修改判断条件与主图/详情图保持一致
          _this15.logoImageUrl = response.url;
          _this15.form.logo = response.url;
          _this15.$message.success('Logo上传成功');
        } else {
          _this15.$message.error('Logo上传失败，请重试');
        }
      }).catch(function (error) {
        console.error('Logo上传错误:', error);
        _this15.$message.error('Logo上传失败，请重试');
      }).finally(function () {
        loadingInstance.close(); // 关闭加载提示
        // 清除文件选择，以便于再次选择同一文件也能触发change事件
        event.target.value = '';
      });
    },
    // 移除logo
    handleRemoveLogo: function handleRemoveLogo() {
      this.logoImageUrl = '';
      this.form.logo = '';
    },
    // 预览logo
    previewLogo: function previewLogo() {
      if (this.logoImageUrl) {
        this.previewVisible = true;
        this.previewImageUrl = this.logoImageUrl;
      }
    },
    // 预览详情logo
    previewDetailLogo: function previewDetailLogo() {
      if (this.detail.logo) {
        this.previewVisible = true;
        this.previewImageUrl = this.detail.logo;
      }
    },
    // 获取诊所详情
    getDetail: function getDetail(id) {
      var _this16 = this;
      this.detailLoading = true;
      this.detailDialogVisible = true;
      (0, _dentalClinicApi.getClinicInfo)(id).then(function (res) {
        if (res) {
          _this16.detail = res;

          // 处理logo
          _this16.detail.logo = res.logo || '';

          // 处理主图
          if (res.mainImage) {
            _this16.mainImageArray = res.mainImage.split(',').filter(function (url) {
              return url && url.trim() !== '';
            });
          } else {
            _this16.mainImageArray = [];
          }

          // 处理详情图
          if (res.detailImage) {
            _this16.detailImageArray = res.detailImage.split(',').filter(function (url) {
              return url && url.trim() !== '';
            });
          } else {
            _this16.detailImageArray = [];
          }

          // 处理标签
          if (res.tags) {
            _this16.detailTagsList = res.tags.split(',').filter(function (tag) {
              return tag && tag.trim() !== '';
            });
          } else {
            _this16.detailTagsList = [];
          }

          // 加载诊所绑定的商品
          _this16.productsQuery.page = 1;
          _this16.loadClinicProducts(id);
        }
      }).catch(function (error) {
        console.error('获取诊所详情失败:', error);
        _this16.$message.error('获取诊所详情失败');
      }).finally(function () {
        _this16.detailLoading = false;
      });
    }
  }
};